import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "ym_admin_token";

export const api = axios.create({ baseURL: `${BACKEND}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgUrl = (src) => {
  if (!src) return "";
  return src.startsWith("/api/") ? `${BACKEND}${src}` : src;
};

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export const formatPrice = (p) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 2 }).format(Number(p) || 0);

export const fillTemplate = (text, s) =>
  (text || "")
    .replaceAll("{company}", s?.company_title || "")
    .replaceAll("{address}", s?.address || "")
    .replaceAll("{phone}", s?.phone || "")
    .replaceAll("{kep}", s?.kep_address || "");

export const waLink = (number, text = "") =>
  `https://wa.me/${(number || "").replace(/\D/g, "")}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const telLink = (phone) => `tel:${(phone || "").replace(/\s/g, "")}`;

export const fmtDate = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return isNaN(d) ? iso : d.toLocaleString("tr-TR", { dateStyle: "medium", timeStyle: "short" });
};
